import { FC } from "react";

type LoadingCircleProps = { readonly size: "sm" | "lg" | null };

export const LoadingCircle: FC<LoadingCircleProps> = (props) => {
  const size = `-${props.size ?? ""}`;

  return (
    <div className={`mkhc-loading-circle${props.size === null ? "" : size}`}>
      <div />
      <div />
      <div />
    </div>
  );
};
